@if (property) {
  <div class="listing-frame listing-map-frame" [class.listing-sponsored]="isSponsered()">
    <span
      class="listing-legend"
      [class.listing-legend-hidden]="!isSponsered()"
      [attr.aria-hidden]="!isSponsered()"
    >
      {{ 'SPONSORED' | translate }}
    </span>
    <button
      type="button"
      class="map-card-close"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="onClose($event)"
      (keydown)="$event.stopPropagation()"
    >
      <i class="bi bi-x" aria-hidden="true"></i>
    </button>

    <div
      class="card listing-card h-100 clickable-card cursor-poiner car-popup-card"
      role="link"
      tabindex="0"
      (keydown.enter)="$event.target === $event.currentTarget && goToDetails(property.id)"
      (click)="goToDetails(property.id)"
    >
      <div class="card popup-card">
        <div class="row g-0">
          <div class="col-6">
            <property-images-carousel-component
              #images
              [displayLikeButton]="false"
              [listingCard]="true"
              [property]="property"
              [carouselId]="listId()"
            ></property-images-carousel-component>
          </div>
          <div class="col-6 px-2 listing-map-details">
            <div class="d-flex justify-content-between mt-2">
              <div class="listing-title-row">
                <h6 class="card-title">
                  <strong>{{ property.title }}</strong>
                  @if (property.status === statuses.Pending) {
                    <span class="badge text-bg-warning">{{ property.status | translate }}</span>
                  }
                </h6>
                @if (!property.isExpired && property.status !== statuses.Sold) {
                  <button
                    type="button"
                    class="listing-favorite"
                    [attr.aria-pressed]="images.isLiked()"
                    [attr.aria-label]="
                      (images.isLiked() ? 'REMOVE_FROM_FAVORITES' : 'ADD_TO_FAVORITES') | translate
                    "
                    (click)="images.toggleLike($event)"
                    (keydown)="$event.stopPropagation()"
                  >
                    <i
                      [class]="images.isLiked() ? 'bi bi-heart-fill' : 'bi bi-heart'"
                      aria-hidden="true"
                    ></i>
                  </button>
                }
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12">
                <p class="card-text">
                  <i class="bi bi-house-door-fill p-1"></i>
                  {{ property.propertyType | translate }}
                </p>
              </div>
              <div class="col-sm-12">
                <p class="card-text">
                  <i class="bi bi-bounding-box-circles p-1"></i>{{ property.floorArea }}/{{
                    property.landArea
                  }}
                  {{ 'M2' | translate }}
                </p>
              </div>
              <div class="col-12">
                <p class="card-text">
                  @if (property.city) {
                    <i class="bi bi-geo-alt-fill p-1"></i>{{ property.city | syrianCity }}
                  }
                </p>
              </div>
              <div class="col-12">
                <p class="card-text">
                  @if (property.rooms) {
                    <i class="bi bi-door-closed-fill p-1"></i>{{ property.rooms }}
                  }
                  @if (property.rooms && property.bathrooms) {
                    /
                  }
                  @if (property.bathrooms) {
                    <span class="p-2"
                      ><img src="icons/shower.png" width="18" height="20" class="white-icon"
                    /></span>
                    <span>{{ property.bathrooms }}</span>
                  }
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
